import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './navigationComponent.module.css';
import UI from '../../constants/ui';
import URL from '../../constants/urls';
import { IMAGE_URL } from '../../constants/apiUrls';
import AvailablePoints from '../availablePoints';
import NotificationIcon from '../notifications/NotificationIcon';
import { SMALL_MOBILE_SCREEN_WIDTH } from '../../constants/screenSize';
import LOGIN_TYPE from '../../constants/loginType';

function RenderMobileView(props) {
  const {
    loggedInUserRole,
    currentHomeUrl,
    activeUrl,
    notificationCount,
    windowWidth,
    isMobileDevice,
    setShouldOpen,
  } = props;

  const BREAK = styles.break;
  const FIND_DIV = styles.findDiv;

  return (
    <>
      <div className="d-flex justify-content-end align-items-center">
        <IconButton onClick={() => setShouldOpen(true)}>
          <div className={`${styles.groupedRoutes} px-2`}>
            <div style={{ position: 'relative' }}>
              <MenuRoundedIcon fontSize="medium" />
            </div>
            {notificationCount > 0 && windowWidth < SMALL_MOBILE_SCREEN_WIDTH && (
              <div
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  zIndex: 1,
                  display: 'inline-flex',
                  flex: '0 0 0%',
                }}
              >
                <div className={classNames(styles.box)} />
              </div>
            )}
          </div>
        </IconButton>
      </div>
      <div
        className={`d-flex ${
          windowWidth < 480 ? 'flex-column' : 'flex-row'
        } align-items-center`}
      >
        <div>
          <Link
            to={currentHomeUrl}
            className={classNames(`${styles.logo} color-1D8FF2`, {
              'me-4': !loggedInUserRole,
            })}
          >
            <img
              src={IMAGE_URL.ALIGNMYCAREER}
              alt={UI.ALT_ALIGNMYCAREER}
              className={`${isMobileDevice ? 'logo_mobile' : 'website_logo'}`}
              width="200px"
              loading="lazy"
              title={UI.ALT_ALIGNMYCAREER}
            />
          </Link>

          {!loggedInUserRole && (
            <>
              <div className={BREAK} />
              <div className={FIND_DIV}>
                <div className="m-2">
                  <Link
                    to={URL.FIND_JOBS}
                    className={`color-1F2830 ${styles.navLink}  ${
                      activeUrl === URL.FIND_JOBS
                        ? `subtitle-1-bold`
                        : 'subtitle-1'
                    }`}
                  >
                    {UI.FIND_JOBS}
                  </Link>
                  {activeUrl === URL.FIND_JOBS ? (
                    <div className={`background-1D8FF2 ${styles.active}`} />
                  ) : (
                    ''
                  )}
                </div>
                <div className="m-2">
                  <Link
                    to={URL.FIND_CANDIDATES}
                    className={`color-1F2830 ${styles.navLink} ${
                      activeUrl === URL.FIND_CANDIDATES
                        ? `subtitle-1-bold ${styles.active}`
                        : 'subtitle-1'
                    }`}
                  >
                    {UI.FIND_TALENT}
                  </Link>
                  {activeUrl === URL.FIND_CANDIDATES ? (
                    <div className={`background-1D8FF2 ${styles.active}`} />
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="d-flex align-items-center">
        {loggedInUserRole &&
          (loggedInUserRole === LOGIN_TYPE.CANDIDATE ||
            loggedInUserRole === LOGIN_TYPE.EMPLOYER) && (
            <>
              <span>
                {loggedInUserRole === LOGIN_TYPE.CANDIDATE && (
                  <AvailablePoints />
                )}
              </span>
              {windowWidth > SMALL_MOBILE_SCREEN_WIDTH && (
                <span>
                  <NotificationIcon />
                </span>
              )}
            </>
          )}
      </div>
    </>
  );
}

RenderMobileView.propTypes = {
  loggedInUserRole: PropTypes.number,
  currentHomeUrl: PropTypes.string.isRequired,
  activeUrl: PropTypes.string.isRequired,
  notificationCount: PropTypes.number.isRequired,
  windowWidth: PropTypes.number.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  setShouldOpen: PropTypes.func.isRequired,
};

RenderMobileView.defaultProps = {
  loggedInUserRole: undefined,
};

export default RenderMobileView;
